module.exports = __webpack_public_path__ + "static/media/custom.f83eb487.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/custom.png
// module id = 7473
// module chunks = 0